import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { FileSignature, ArrowRight } from "lucide-react";
import { fmtDate } from "@/lib/format";
import { RemindButton } from "@/components/RemindButton";

const ST = { getekend: ["Getekend", "bg-emerald-100 text-emerald-700"], verzonden: ["Verzonden", "bg-amber-100 text-amber-700"], "deels getekend": ["Deels getekend", "bg-amber-100 text-amber-700"], concept: ["Concept", "bg-slate-100 text-slate-600"] };

export const ClientAgreements = ({ clientId, tenantId, hideEmpty }) => {
  const [rows, setRows] = useState([]);
  const navigate = useNavigate();
  const load = () => api.get("/agreements/overview").then((r) => setRows(r.data.filter((a) => tenantId ? a.tenant_id === tenantId : a.party_type === "client" && a.client_id === clientId))).catch(() => {});
  useEffect(() => { load(); }, [clientId, tenantId]); // eslint-disable-line react-hooks/exhaustive-deps
  if (hideEmpty && rows.length === 0) return null;
  return (
    <Card className={`p-5 ${tenantId ? "" : "mt-4"}`} data-testid={tenantId ? "tenant-agreements" : "client-agreements"}>
      <div className="flex items-center justify-between mb-3">
        <h3 className="font-heading font-semibold flex items-center gap-2 text-[#0F1E3D]"><FileSignature className="h-4 w-4 text-[#C9A227]" /> {tenantId ? "Documenten ter ondertekening" : "Overeenkomsten"} ({rows.length})</h3>
        <Button size="sm" variant="outline" className="border-[#C9A227]/70 text-[#0F1E3D]" onClick={() => navigate("/app/contracten")} data-testid="client-agreements-open">Naar Contracten <ArrowRight className="h-4 w-4 ml-1" /></Button>
      </div>
      {rows.length === 0 ? <p className="text-sm text-slate-400">Nog geen overeenkomsten ter ondertekening.</p> : (
        <div className="divide-y">
          {rows.map((a) => {
            const [l, c] = ST[a.status] || ST.concept;
            return (
              <div key={a.id} className="flex flex-wrap items-center justify-between gap-2 py-2 text-sm" data-testid={`client-agreement-${a.id}`}>
                <div className="min-w-0"><div className="font-medium text-[#0F1E3D] truncate">{a.title}</div><div className="text-xs text-slate-400">Opgesteld {fmtDate(a.created_at)}{a.signed_at ? ` · getekend ${fmtDate(a.signed_at)} door ${a.signer_name}` : ""}</div></div>
                <div className="flex items-center gap-2 shrink-0">
                  <RemindButton agreement={a} onDone={load} testId={`client-agreement-remind-${a.id}`} />
                  <span className={`text-[11px] px-2 py-0.5 rounded-full font-medium ${c}`}>{l}</span>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </Card>
  );
};
